import React, { useEffect, useState } from "react";
import axios from "axios";
import { t } from "i18next";
import "./CurrentProjects.css";
import SliderCurrentProject from "./SliderCurrentProject";

function tr(key, fallback) {
  const value = t(key);
  return value && value !== key ? value : fallback;
}

export default function CurrentProjects() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    axios
      .get(process.env.REACT_APP_BACKEND_LINK + "/projects/")
      .then((response) => {
        if (!isMounted) return;

        setProjects(Array.isArray(response.data) ? response.data : []);
      })
      .catch((error) => {
        console.error("Projects loading error:", error);

        if (isMounted) {
          setProjects([]);
        }
      })
      .finally(() => {
        if (isMounted) {
          setLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="skyua-current-projects">
      <div className="skyua-current-projects__heading">
        <span className="skyua-current-projects__eyebrow">
          {t("actual projects title")}
        </span>

        <h2>
          {tr(
            "home projects heading",
            "Програми, які вже працюють у громадах"
          )}
        </h2>
      </div>

      {loading ? (
        <div className="skyua-current-projects__loading">
          {tr("loading", "Завантаження...")}
        </div>
      ) : projects.length > 0 ? (
        <SliderCurrentProject currentProj={projects} />
      ) : (
        <div className="skyua-current-projects__empty">
          {tr("no projects", "Наразі проєкти не знайдено")}
        </div>
      )}
    </div>
  );
}
